import { useState } from 'react'
import parse from 'html-react-parser'
import { useFontSize } from '@/site/hooks/useFontSize'

/** `snippet` is the transcript as HTML (newlines already converted to <br>). */
export default function VideoTranscript({ snippet }: { snippet: string }) {
  const [showMore, setShowMore] = useState(false)
  const { fontSizeUI, fontSizeClass } = useFontSize()

  return (
    <section aria-labelledby="transcript" className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <h2 id="transcript" className="text-2xl font-extrabold md:text-[28px]">
          Video Transcript
        </h2>
        {fontSizeUI}
      </div>
      <div className="rounded-3xl border-2 border-qt-line p-5 md:p-7">
        {/* Collapsed with CSS only, so the whole transcript is in the page for search engines. */}
        <div className={`${fontSizeClass} leading-relaxed ${showMore ? '' : 'max-h-64 overflow-hidden [mask-image:linear-gradient(to_bottom,#000_70%,transparent)]'}`}>
          {parse(snippet)}
        </div>
        <button
          type="button"
          aria-expanded={showMore}
          onClick={() => setShowMore(!showMore)}
          className="mt-4 rounded-xl border-2 border-qt-text px-5 py-2.5 text-sm font-bold hover:bg-qt-soft"
        >
          {showMore ? 'Show less' : 'Read the whole transcript'}
        </button>
      </div>
    </section>
  )
}
